import React from "react";
import {getImageUrl} from "../../api/util";
import _ from "lodash";

const TeaserImage = ({image}) => (
    _.isNil(image) ? <></> : <img className="w-100 my-md-5 my-3" src={getImageUrl(image)} alt={image.name}/>
)

export default TeaserImage;